import { render, staticRenderFns } from "./DefaultChart.vue?vue&type=template&id=1356be5d"
import script from "./DefaultChart.vue?vue&type=script&lang=js"
export * from "./DefaultChart.vue?vue&type=script&lang=js"
import style0 from "./DefaultChart.vue?vue&type=style&index=0&id=1356be5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports